<template>
	<AnalyticsCard class="card-container">
		<Col class="width-100 height-100">
			<Row class="flex-align-center flex-justify-space-between mb-5">
				<h3 v-if="title" class="reg heavy">{{ title }}</h3>
				<h3 v-if="additionalTitle" class="reg heavy">{{ additionalTitle }}</h3>
				<router-link v-else-if="linkOnTop" :to="to" class="router">
					<AnemicButton class="link-button px-1" tile>{{ linkText }}</AnemicButton>
				</router-link>
			</Row>
			<Col class="height-100 flex-justify-space-between">
				<slot class="height-100" />
				<Col v-if="toRouteName && !linkOnTop">
					<div class="divider mb-4 width-100" />
					<Row class="width-100 flex-end--center">
						<router-link :to="to" class="router">
							<AnemicButton class="link-button px-1" tile>{{ linkText }}</AnemicButton>
						</router-link>
					</Row>
				</Col>
			</Col>
		</Col>
	</AnalyticsCard>
</template>
<script>
import AnalyticsCard from '@/components/Analytics/Cards/AnalyticsCard.vue';
import CreateAndManageService from '@/views/AppLayout/ManageAndCreate/create-and-manage-service.js';
export default {
	name: 'AnalyticsSectionPreviewCard',
	components: { AnalyticsCard },
	props: {
		title: { type: String },
		linkText: { type: String },
		linkOnTop: { type: Boolean },
		toRouteName: { type: String },
		additionalTitle: { type: String },
	},
	computed: {
		to() {
			return { name: this.routeNamePrefix + this.toRouteName, query: this.$route.query };
		},
		routeNamePrefix() {
			return CreateAndManageService.getPlacementRoutePrefix(this.$route);
		},
	},
};
</script>
<style scoped lang="scss">
.card-container {
	padding: 20px 20px 14px 20px;
}
.divider {
	min-height: 1px;
	max-height: 1px;
	background: #e2e7f0;
}
.link-button {
	height: 25px !important;
	width: 120px !important;
	font-size: 14px !important;
	color: #727a96 !important;
	border-radius: 6px !important;
	font-weight: normal !important;
	letter-spacing: 0px !important;
	background: #ffffff !important;
	border: 1px solid #cccfd8 !important;
}
.router {
	text-decoration: none;
}
</style>
